import React from "react";
import t from '../../../helpers/t';
import Biscuit from '../../../../utils/Biscuit';

const NewVoucherButtton = (props) => {
  return (
    <>
      <a
          href={"vouchers/add"+ props.currentUrl.search}
          id="inb-c-left-bar-add-voucher"
          className={"button beautify beautify-" + Biscuit.get('user.client_id')}
      >
          <i className="fi fi-page-add"></i>
          <span>
              {t('add_${a}',{a:t('voucher',null, 'capital')})}
          </span>
      </a>
    </>
  );
};
export default NewVoucherButtton;